import { render, staticRenderFns } from "./shopLogo.vue?vue&type=template&id=6ec41d97&"
import script from "./shopLogo.vue?vue&type=script&lang=js&"
export * from "./shopLogo.vue?vue&type=script&lang=js&"
import style0 from "./shopLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports